import React, { Component } from "react";
import SearchSelect from "../../../../../../../components/searchSelect/SearchSelect";
import { InputFactory, dialog } from "nq-component";
import BaseListPage from "../../../../../../../base/BaseListPage";
import Presenter from "../../../../../../HumanResource/Employees/forms/DropdownTable/Presenter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../../usecases/object";

export default class EarningEdit extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new Presenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      description: "",
      amount: "",
    };
  }

  getCollectionName() {
    return "earning";
  }
  componentDidMount() {
    this.presenter.componentDidMount();
    const object = this.props.object;

    this.setState({
      description: object.description,
      amount: object.amount,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.props.object) {
    }
  }

  onChangeDescription(description) {
    this.setState({ description });
  }
  onChangeAmount(amount) {
    this.setState({ amount });
  }

  async handleSaveButton() {
    if (this.state.description === "") {
      this.showError("Description is required");
    } else if (this.state.amount === "") {
      this.showError("Amount is required");
    } else {
      const data = {
        description: this.state.description,
        amount: this.state.amount,
        id: this.props.object.id,
      };
      console.warn("Updated DATA: ", data);
      this.props.Earning(data, true);
      dialog.close();
    }
  }
  render() {
    const object = this.props.object;

    return (
      <>
        <div>
          <h4>Update Earning</h4>
          <hr />
          <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
            Description <span style={{ color: "red" }}>*</span>
          </label>
          <InputFactory
            type="String"
            field="description"
            object={object}
            onChange={this.onChangeDescription.bind(this)}
          />

          <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
            Amount
          </label>
          <InputFactory
            type="Number"
            field="amount"
            object={object}
            onChange={this.onChangeAmount.bind(this)}
          />

          <div className="mt-4 mb-4 d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-light fs-sm me-3"
              onClick={() => dialog.close()}
            >
              Cancel
            </button>
            <button
              onClick={this.handleSaveButton.bind(this)}
              className="btn btn-primary fs-sm me-3"
            >
              Save
            </button>
          </div>
        </div>
      </>
    );
  }
}
